import { crudMdActions } from "@/services/crud-md-actions";

const name = "clients";

export default {
  name,
  ...crudMdActions(name),
};
